export default "__VITE_ASSET__4iCZMA5d__"